// import dependencies
import React, { Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Review from 'components/Review/';
import { space } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';

import { reviewsPerReviewsPage } from 'constants';
import WithHotelReviews from 'containers/WithHotelReviews';

const ReviewsContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    ${space};
`;

const ReviewStyled = styled(Review)`
    margin: ${themeGet('space.2')}px 0px;
`;

const MoreReviewsButton = styled.a`
    color: ${themeGet('colors.blue')};
    cursor: pointer;
`;

export const ReviewsContainer = ({ reviews, limit, hotelId, filter, redirected, ...props }) => {
    const rtn = [];

    if (props.isClient) {
        return (
            <WithHotelReviews
                hotelId={hotelId}
                filter={filter}
                first={reviewsPerReviewsPage}
                redirected={redirected}
                dataReviews={reviews}
                render={(reviews, hasMoreReviews, fetchReviews) => {
                    return (
                        <Fragment>
                            {reviews.length > 0 ? (
                                reviews.map((review, index) => (
                                    <div key={index}>
                                        <ReviewStyled review={review} />
                                    </div>
                                ))
                            ) : (
                                <div>Sorry, this type of review is currently unavailable.</div>
                            )}
                            {hasMoreReviews && (
                                <MoreReviewsButton onClick={() => fetchReviews()}>Show More Reviews</MoreReviewsButton>
                            )}
                        </Fragment>
                    );
                }}
            />
        );
    }

    if (!reviews) {
        return null;
    }
    if (!limit || reviews.length < limit) {
        limit = reviews.length;
    }
    for (let count = 0; count < limit; count++) {
        rtn.push(
            <div key={count}>
                <ReviewStyled review={reviews[count]} />
            </div>
        );
    }

    return <ReviewsContainerStyled {...props}>{rtn}</ReviewsContainerStyled>;
};

ReviewsContainer.propTypes = {
    reviews: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.bool
    ]),
    limit: PropTypes.number,
    isClient: PropTypes.bool,
    hotelId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    filter: PropTypes.string,
    redirected: PropTypes.bool
};

export default ReviewsContainer;
